import { ConnectPayments } from "@stripe/react-connect-js";
import { Col, Container, Row } from "react-bootstrap";
import { PageTitle } from "./Controls/PageTitle";

export function FacilityFinanceStripePaymentListPage() {
    return <Container fluid>
        <Row>
            <Col>
                <PageTitle>
                    Payments
                </PageTitle>
                <ConnectPayments />
            </Col>
        </Row>
    </Container>;
}